var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid dashboard",attrs:{"id":"app"}},[_c('legacy-app-notice'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('mainMenu'),_vm._v(" "),_c('transition',{attrs:{"name":_vm.transitionName,"mode":"out-in"}},[_c('router-view',{staticClass:"view"})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-873f7602","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = bmfq
// module chunks = 47